<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" :model="form" :rules="rules" ref="form" label-width="140px">
        <el-row :span="24">
          <!-- <el-col :span="12">
            <el-form-item label="姓名" prop="userName">
              <el-input
                v-model="form.userName"
                placeholder="请输入姓名"
              /> </el-form-item
          ></el-col> -->
          <el-col :span="12">
            <el-form-item label="所属客户" prop="userId">
              <el-select v-model="form.userId">
                <el-option :label="item.userName" :value="item.userId" v-for="(item, index) of userList"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>

          <el-col :span="12">
            <el-form-item label="成品油类型" prop="oilType">
              <el-select v-model="form.oilType" filterable>
                <el-option :value="item.oilType" :label="item.oilTypeName" v-for="(item, index) of typeList"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="每日/单价" prop="unitPrice">
              <el-input-number v-model="form.unitPrice" :min="0" :max="99999999"></el-input-number>
            </el-form-item>

          </el-col>
        </el-row>
        <el-row>

          <el-col :span="12">
            <el-form-item label="单位" prop="ygUnit">
              <el-select v-model="form.ygUnit" filterable>
                <el-option :value="item.dicCode" :label="item.dicValue" v-for="(item, index) of unitList"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开始计价日期" prop="ygDate">
              <el-date-picker v-model="form.ygDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
                placeholder="请选择开始计价日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>

          <el-col :span="12">
            <el-form-item label="合同金额" prop="ygPrice">
              <el-input-number v-model="form.ygPrice" :min="0" :max="99999999"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="数量" prop="ygNumber">
              <el-input-number v-model="form.ygNumber" :min="0" :max="99999999"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12"></el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="附件">
              <file-upload v-model="form.fileList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" @click="submit" class="global-button">保存</el-button>
          <el-button @click="$router.back()" class="global-button">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
export default {
  name: 'YgUserAdd',
  data() {
    return {
      userList: [],
      ygList: [],
      typeList: [],
      roles: [],
      unitList: [],
      form: {
        // loginId: '', // 登录账号
        // mobile: '', // 手机号
        // roleId: '', // 用户角色
        // password: '', // 密码
        // deptId: '1',
        userName: null,
        // userType: '3',
        ygNumber: null,
        oilType: null,
        unitPrice: null,
        ygDate: null,
        ygPrice: null,
        ygUnit: null,
        userId: null,
        fileList: []

      },
      rules: {
        userId: [{ required: true, message: '请选择业务员', trigger: 'change' }],

        userName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        ygId: [{ required: true, message: '请选择油罐', trigger: 'change' }],
        oilType: [{ required: true, message: '请选择成品油类型', trigger: 'change' }],
        ygUnit: [{ required: true, message: '请选择单位', trigger: 'change' }],
        ygDate: [{ required: true, message: '请选择开始计价日期', trigger: 'change' }],
        unitPrice: [{ required: true, message: '请输入每日/单价', trigger: 'blur' }],
        ygPrice: [{ required: true, message: '请输入合同金额', trigger: 'blur' }],
        ygNumber: [{ required: true, message: '请输入数量', trigger: 'blur' }]

      }
    }
  },
  computed: {
    ygId() {
      return this.$route.query.ygId
    },
    user() {
      return this.$store.state.user
    },
    unitData() {
      return this.$store.state.unitList
    }
  },
  created() {
    this.loadType()
    this.loadOliTypeList()
    if (this.ygId) {
      this.loadDetails()
    }
  },
  methods: {
    loadOliTypeList() {
      this.$axios.get(this.$apis.oiltabkManage.selectYgOilTypeByPage).then(res => {
        this.typeList = res.list
      })
    },
    loadRoles() {
      this.$axios.get(this.$apis.system.selectSysRoleByList).then(res => {
        this.roles = res
      })
    },
    loadType() {
      // 储油类型
      this.$axios.get(this.$apis.common.selectDicByList, {
        params: { dicType: 'ygUnit' }
      }).then(res => {
        // this.typeList = res.ygType || []
        this.unitList = res.ygUnit || []
      })
      // 油罐
      this.$axios.get(this.$apis.oiltabkManage.selectYgInfoByList).then(res => {
        this.ygList = res.list || []
      })
      this.$axios.get(this.$apis.system.selectSysUserByPage, {
        userType: '2',
        page: 1,
        size: 999
      }).then(res => {
        this.userList = res.list
      })
    },
    loadDetails() {
      this.$axios.get(this.$apis.oiltabkManage.selectYgUserInventoryByYgId, {
        params: { ygId: this.ygId }
      }).then(res => {
        this.form = res
      })
    },
    submit() {
      this.$refs.form.validate().then(() => {
        let url = this.$apis.oiltabkManage.insertYgUserInventory
        if (this.ygId) {
          url = this.$apis.oiltabkManage.updateYgUserInventory
        }

        this.$axios.post(url, this.form).then(res => {
          // this.$store.dispatch('getUserList')
          this.$router.back()
        })
      })
    },

    loadDepts() {
      this.$axios.get(this.$apis.system.selectSysDeptByList).then(res => {
        this.depts = res
      })
    },
    closeCascader() {
      this.$refs.cascader.dropDownVisible = false
    },
    loadDict() {
      this.$axios.get(this.$apis.common.selectDicByList, {
        params: { dicType: 'userType' }
      }).then(res => {
        this.userType = res.userType
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.el-select,
.el-input,
.el-cascader,
.el-input-number {
  width: 95%;
}
</style>
